import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-user-portal-layout',
  templateUrl: './user-portal-layout.component.html',
  styleUrls: ['./user-portal-layout.component.css']
})
export class UserPortalLayoutComponent implements OnInit {
  constructor() {}
  ngOnInit() {}
}
